import { Box, Button, Flex, Grid, GridItem } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CategoryGrid } from "../components/home/categoryGrid";
import { FiltersBanner } from "../components/catalog/searchBar/filtersBanner";
import { useFiltersBanner, useValidateSession, useAppConfig } from "../hooks/index";
import { TypeCallbackSearch } from "../app/types/types";
import { Category } from "../../api/src/types/types";
import { calculateMaxFilter } from "../utils/filterUtils";
import { useUserStore } from "../stores/userStore";

export interface HomePageProps {}

export const HomePage = (props: HomePageProps) => {
  const { user: sessionUser } = useValidateSession(null);
  const { user } = useUserStore();
  const { ctaColor, ctaTextColor } = useAppConfig();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  
  const { filterBtnRef, filterIsOpen, filterOnClose, filterOnOpen } = useFiltersBanner();

  // Query search state per il FiltersBanner
  const [querySearch] = useState({
    categories: [],
    keyword: "",
    rangeValue: [0, calculateMaxFilter(user.collections)],
  });

  // Callback per gestire la ricerca dal FiltersBanner
  const doSearch: TypeCallbackSearch = (
    selectedCat: Category[],
    selectedKeywords: string,
    rangeValues: number[]
  ): void => {
    filterOnClose();
    
    // Naviga al catalogo con i filtri applicati
    const searchParams = new URLSearchParams({
      filters: "true",
      pmin: rangeValues[0].toString(),
      pmax: rangeValues[1].toString(),
      keywords: selectedKeywords,
      category: selectedCat
        .map((element) => element.key.toString())
        .join(","),
    });
    
    navigate(`/catalog?${searchParams.toString()}`);
  };

  return (
    <Box 
      className="homepage"
      p="1em"
      w="100%"
      fontSize={["sm", "md"]}
    >
      {/* Header sticky con bottone filtri - stile identico a CatalogContent */}
      <Flex
        pt={2}
        pb={2}
        as="header"
        position="sticky"
        w="100%"
        backgroundColor="rgba(255, 255, 255, 0.8)"
        backdropFilter="saturate(180%) blur(5px)"
        zIndex="200"
        top="0"
        mb={4}
      >
        <Grid templateColumns="repeat(6, 1fr)" w="100%">
          <GridItem w="100%" h="10">
            <Button
              rightIcon={<ChevronDownIcon />}
              ref={filterBtnRef}
              onClick={filterOnOpen}
              bgColor={ctaColor}
              color={ctaTextColor}
              _hover={{ bg: ctaColor }}
              _active={{
                bg: ctaColor,
                transform: "scale(0.98)",
                borderColor: ctaColor,
              }}
            >
              Filtri
            </Button>
          </GridItem>
        </Grid>
      </Flex>
      
      {/* Griglia Categorie */}
      <CategoryGrid />
      
      {/* FiltersBanner */}
      <FiltersBanner
        isOpen={filterIsOpen}
        onClose={filterOnClose}
        btnRef={filterBtnRef}
        callbackSearch={doSearch}
        querySearch={querySearch}
        excludeCategories=""
      />
    </Box>
  );
};
